export default function maskPortfolio(portfolioId, rsaAuthorised) {
  if (rsaAuthorised) {
    return portfolioId;
  } else {
    return portfolioId.substr(0, 1) + 'XXXXX' + portfolioId.slice(6);
  }
}
